import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {BuildingAdd as BuildingAddIcon} from 'react-bootstrap-icons';
import {addJob} from '../../features/jobs';

const CreateJob = (props) => {
  const dispatch = useDispatch();

  const [isSubmitted, setSubmitted] = useState(false);

  const [job, setJob] = useState({name: '', active: 1});

  const reset = () => {
    setSubmitted(false);
    setJob({name: ''});
  }

  const save = async () => {

    try {
      await dispatch(addJob(job));

      reset();
    } catch (err) {
    }
    finally {

    }
  };

  return (
      <div className="mt-3 mb-5">
        {isSubmitted ? (
            <div>
              <h4>You submitted successfully!</h4>
              <button className="btn btn-success" onClick={reset}>
                Add
              </button>
            </div>
        ) : (
            <button onClick={save} className="btn btn-success">
              <BuildingAddIcon/> Job anlegen
            </button>
        )}

      </div>

  );
}

export default CreateJob;
